// Uploaded-file helpers: chunked upload + authenticated file URLs
import api from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

export const fileUrl = (u) => {
  if (!u) return "";
  if (/^(data:|blob:)/.test(u)) return u;
  if (/^https?:/.test(u)) {
    try {
      const url = new URL(u);
      const backend = new URL(process.env.REACT_APP_BACKEND_URL || window.location.origin);
      if ((url.origin === backend.origin || url.origin === window.location.origin) && url.pathname.startsWith("/api/")) u = url.pathname + url.search;
      else return u;
    } catch { return u; }
  }
  if (u.startsWith("/images/") || u.startsWith("/assets/")) return u;
  const token = localStorage.getItem("hrm_token") || "";
  const path = u.startsWith("/") ? u : `/${u}`;
  return `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}${path}${path.includes("?") ? "&" : "?"}auth=${encodeURIComponent(token)}`;
};

export async function uploadFile(file, onProgress) {
  const { data: init } = await api.post("/admin/uploads/init", { filename: file.name, size: file.size });
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", init.upload_id);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
    for (let attempt = 0; ; attempt++) {
      try {
        await api.post("/admin/uploads/chunk", fd, { timeout: 120000, onUploadProgress: e => onProgress?.(Math.round((i + (e.total ? e.loaded / e.total : 0)) / total * 95)) });
        break;
      } catch (error) {
        if (attempt >= 2 || (error.response?.status && error.response.status < 500)) throw error;
        await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)));
      }
    }
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post("/admin/uploads/complete", {
    upload_id: init.upload_id, filename: file.name, content_type: file.type,
  }, { timeout: 300000 });
  onProgress?.(100);
  return data;
}

export const prettySize = (n = 0) =>
  n > 1048576 ? `${(n / 1048576).toFixed(1)} م.ب` : `${Math.max(1, Math.round(n / 1024))} ك.ب`;
